import React, { Component } from "react";
import { toast } from "react-toastify";
import "./facturaPublicaDetalleModal.css";

export default class VerDetallesFacModal extends Component {
    state = {
        showMiniModal: false,
        showConfirmNotaCredito: false,

        showCancelarModal: false,
        showConfirmCancelarFactura: false,
        fecha_nota: new Date().toISOString().slice(0, 10),

        pagoSeleccionado: null,
        opcionNotaCredito: "",
        opcionFormaPago: "",
        descripcionDetallada: "",
        opcionCancelarFactura: "",
        montoNotaCredito: "",
        bandera_nota_credito: "", // solo son dos posibles respuesta o es general o sola
    };

    parseNumber = (value) => {
        if (value == null || value === "") return 0;

        let clean = String(value).trim();
        clean = clean.replace(/\s/g, "");

        if (clean.includes(",") && !clean.includes(".")) {
            clean = clean.replace(",", ".");
        } else if (clean.includes(",") && clean.includes(".")) {
            clean = clean.replace(/,/g, "");
        }

        const n = Number(clean);
        return Number.isNaN(n) ? 0 : n;
    };

    roundMoney = (value) => {
        const n = Number(value || 0);
        return Math.round((n + Number.EPSILON) * 100) / 100;
    };

    formatMoney = (value) => {
        return this.roundMoney(value).toFixed(2);
    };

    formatCurrency = (value) => {
        return `$ ${this.formatMoney(value)}`;
    };

    getCatalogItems = (key) => {
        return this.props.catalogos?.[key] || [];
    };

    getTipoRelacionOptions = () => {
        return this.getCatalogItems("tipo_relacion").map((x) => ({
            value: x?.clave || "",
            label: `${x?.clave || ""} ${x?.tipo_relacion || ""}`.trim(),
        }));
    };

    getMotivoCancelacionOptions = () => {
        return this.getCatalogItems("motivo_cancelacion").map((x) => ({
            value: x?.clave || "",
            label: `${x?.clave || ""} ${x?.motivo_cancelacion || ""}`.trim(),
        }));
    };

    getData = () => {
        const item = this.props.data || {};
        const itempadre = this.props.datapadre || {};
        const afiliacion = item?.afiliacion || {};
        const solicitud = item?.solicitud || {};
        const emisor = item?.emisor || {};
        const pagos = Array.isArray(item?.pagos) ? item.pagos : [];
        const productos = Array.isArray(item?.productos) ? item.productos : [];

        // console.log(JSON.stringify(item));
        return {
            item,
            afiliacion,
            solicitud,
            emisor,
            pagos,
            productos,
            resumen: {
                idfactura: itempadre?.idfactura || "",
                estatusPAdre: itempadre?.estatus || "",
                folio: itempadre?.folio || "",

                monedafactura: item?.monedafactura || solicitud?.moneda || "",
                totalfactura: this.formatMoney(Number(item.totalfactura || 0)),
                ivafactura: this.formatMoney(item.ivafactura || 0),
                tipocambiofactura: item?.tipocambiofactura || 1,
            },
        };
    };

    isFacturaCancelada = () => {
        const { resumen } = this.getData();
        const estatus = String(resumen?.estatusPAdre || "").trim().toLowerCase();
        return estatus === "cancelado";
    };

    renderReadField = (label, value, extraClass = "", valueClass = "") => (
        <div className={`vd-field ${extraClass}`}>
            <label>{label}</label>
            <div className={`vd-value ${valueClass}`}>{value || "—"}</div>
        </div>
    );

    renderResumen = () => {
        const { solicitud, resumen } = this.getData();
        const tipo_solicitud = (solicitud.tipo_solicitud || "").toUpperCase();

        return (
            <div className="vd-summaryBar">
                <div className="vd-summaryMain">
                    <div className="vd-summaryTitle">
                        Factura #{resumen.folio || "—"}
                    </div>
                    {solicitud.notacredito === 1 ? (
                        <div style={{ fontWidth: "bold", fontSize: "medium", color: "black", paddingLeft: "10px" }} className="vd-cardDesc"><b>Relación:</b>{" "}{solicitud.tipo_relacion_descripcion || ""}
                            <br />
                            <b>Detalles:{" "}</b>{solicitud.descripcion_detallada || ""}
                        </div>
                    ) : null}

                </div>

                <div className="vd-summaryStats">


                    <div className="vd-stat">
                        <span className="vd-statLabel">Tipo factura</span>
                        <span className="vd-statValue">{tipo_solicitud || "—"}</span>
                    </div>

                    <div className="vd-stat">
                        <span className="vd-statLabel">Moneda</span>
                        <span className="vd-statValue">
                            {resumen.monedafactura || solicitud.moneda || "—"}
                        </span>
                    </div>

                    <div className="vd-stat">
                        <span className="vd-statLabel">Fecha factura</span>
                        <span className="vd-statValue">
                            {String(solicitud.fecha_factura || "").slice(0, 10) || "—"}
                        </span>
                    </div>

                    <div className="vd-stat">
                        <span className="vd-statLabel">Estatus</span>
                        <span className="vd-statValue" style={{ "color": solicitud.estatus === "Facturado" ? "#16a34a" : "#d42831" }}>{solicitud.estatus || "—"}</span>
                    </div>
                </div>
            </div>
        );
    };

    getTodayLocal = () => {
        const today = new Date();
        const offset = today.getTimezoneOffset();
        const localDate = new Date(today.getTime() - (offset * 60000));
        return localDate.toISOString().slice(0, 10);
    };

    openMiniNotaCredito = (pago) => {
        if (this.isFacturaCancelada()) return;

        this.setState({
            showMiniModal: true,
            showConfirmNotaCredito: false,
            pagoSeleccionado: pago,
            opcionNotaCredito: "",
            opcionFormaPago: "",
            descripcionDetallada: "",
            montoNotaCredito: "",
            bandera_nota_credito: "solo",
            fecha_nota: this.getTodayLocal(),
        });
    };

    closeMiniNotaCredito = () => {
        this.setState({
            showMiniModal: false,
            showConfirmNotaCredito: false,
            pagoSeleccionado: null,
            opcionNotaCredito: "",
            opcionFormaPago: "",
            descripcionDetallada: "",
            montoNotaCredito: "",
            bandera_nota_credito: "",
        });
    };

    getFormaPagoOptions = () => {
        return this.getCatalogItems("forma_pago").map((x) => ({
            value: x?.clave || "",
            label: `${x?.clave || ""} ${x?.forma_pago || ""}`.trim(),
        }));
    };

    onGuardarNotaCredito = () => {
        const {
            pagoSeleccionado,
            opcionNotaCredito,
            opcionFormaPago,
            descripcionDetallada,
            bandera_nota_credito,
            montoNotaCredito,
        } = this.state;






        if (!String(opcionNotaCredito || "").trim()) {
            toast.info("Selecciona el tipo de relación.");
            return;
        }

        if (!String(opcionFormaPago || "").trim()) {
            toast.info("Selecciona la forma de pago.");
            return;
        }

        if (bandera_nota_credito === "solo" && !pagoSeleccionado?.idticketpago) {
            toast.info("No se encontró el pago seleccionado.");
            return;
        }

        if (bandera_nota_credito === "general") {
            const monto = this.parseNumber(montoNotaCredito);

            if (!monto || monto <= 0) {
                toast.info("Agrega un monto válido.");
                return;
            }
        }

        if (!String(descripcionDetallada || "").trim()) {
            toast.info("Agrega los detalles.");
            return;
        }

        this.setState({ showConfirmNotaCredito: true });
    };

    onConfirmarNotaCredito = async () => {
        const {
            pagoSeleccionado,
            opcionNotaCredito,
            opcionFormaPago,
            descripcionDetallada,
            bandera_nota_credito,
            montoNotaCredito,
        } = this.state;
    
        const { resumen } = this.getData();
    
        if (!String(opcionNotaCredito || "").trim()) {
            toast.info("Selecciona el tipo de relación.");
            return;
        }
    
        if (!String(opcionFormaPago || "").trim()) {
            toast.info("Selecciona la forma de pago.");
            return;
        }
    
        if (!String(descripcionDetallada || "").trim()) {
            toast.info("Agrega los detalles.");
            return;
        }
    
        if (bandera_nota_credito === "solo") {
            if (!pagoSeleccionado?.idticketpago) {
                toast.info("No se encontró el pago seleccionado.");
                return;
            }
    
            await this.props.onNotaCredito?.({
                fecha: this.state.fecha_nota,
                idfactura: String(resumen?.idfactura || ""),
                idticketpago: Number(pagoSeleccionado.idticketpago),
                clave_tipo_relacion: opcionNotaCredito,
                clave_forma_pago: opcionFormaPago,
                descripcion_detallada: String(descripcionDetallada).trim(),
            });
        }
    
        if (bandera_nota_credito === "general") {
            const monto = this.parseNumber(montoNotaCredito);
    
            if (!monto || monto <= 0) {
                toast.info("Agrega un monto válido.");
                return;
            }
    
            await this.props.onNotaCreditoGeneral?.({
                fecha: this.state.fecha_nota,
                idfactura: String(resumen?.idfactura || ""),
                clave_tipo_relacion: opcionNotaCredito,
                clave_forma_pago: opcionFormaPago,
                descripcion_detallada: String(descripcionDetallada).trim(),
                monto: this.roundMoney(monto),
            });
        }
    
        this.closeMiniNotaCredito();
    };

    openNotaCreditoGenral = () => {
        if (this.isFacturaCancelada()) return;

        this.setState({
            showMiniModal: true,
            showConfirmNotaCredito: false,
            pagoSeleccionado: null,
            opcionNotaCredito: "",
            opcionFormaPago: "",
            descripcionDetallada: "",
            montoNotaCredito: "",
            bandera_nota_credito: "general",
            fecha_nota: this.getTodayLocal(),
        });
    };

    openCancelarFacturaModal = () => {
        if (this.isFacturaCancelada()) return;

        this.setState({
            showCancelarModal: true,
            showConfirmCancelarFactura: false,
            opcionCancelarFactura: "",
        });
    };

    closeCancelarFacturaModal = () => {
        this.setState({
            showCancelarModal: false,
            showConfirmCancelarFactura: false,
            opcionCancelarFactura: "",
        });
    };

    onGuardarCancelarFactura = () => {
        const { opcionCancelarFactura } = this.state;

        if (!String(opcionCancelarFactura || "").trim()) {
            toast.info("Selecciona el motivo de cancelación.");
            return;
        }

        this.setState({ showConfirmCancelarFactura: true });
    };


    onConfirmarCancelarFactura = () => {
        const { resumen } = this.getData();
        const { opcionCancelarFactura } = this.state;

        if (!String(opcionCancelarFactura || "").trim()) {
            toast.info("Selecciona el motivo de cancelación.");
            return;
        }

        if (this.props.onCancelarFactura) {
            this.props.onCancelarFactura({
                idfactura: String(resumen?.idfactura || ""),
                clave_cancelacion: opcionCancelarFactura,
            });
        }

        this.closeCancelarFacturaModal();
    };

    renderMiniModal = () => {
        const {
            showMiniModal,
            showConfirmNotaCredito,
            pagoSeleccionado,
            opcionNotaCredito,
            opcionFormaPago,
            descripcionDetallada,
            montoNotaCredito,
            bandera_nota_credito,
        } = this.state;

        const tipoRelacionOptions = this.getTipoRelacionOptions();
        const formaPagoOptions = this.getFormaPagoOptions();

        if (!showMiniModal) return null;

        return (
            <div className="vd-miniBackdrop">
                <div className="vd-miniModal">
                    {!showConfirmNotaCredito ? (
                        <>
                            <div className="vd-miniTitle">Nota de crédito</div>

                            {bandera_nota_credito === "solo" ? (
                                <div className="vd-miniText" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <strong>Pago:</strong>{" "}
                                    <strong>
                                        {pagoSeleccionado?.idticket ||
                                            pagoSeleccionado?.idticketpago ||
                                            "—"}
                                    </strong>
                                </div>
                            ) : null}


                            <br />
                            <div className="vd-field">
                                <label style={{ fontWeight: "bold", color: "black" }}>Fecha de Nota de crédito</label>
                                <input
                                    className="vd-statInput"
                                    type="date"
                                    value={String(this.state.fecha_nota || "").slice(0, 10)}
                                    onChange={(e) =>
                                        this.setState({ fecha_nota: e.target.value })
                                    }
                                />
                            </div>


                            <div className="vd-field" style={{ marginTop: 12 }}>
                                <label>Tipo de relación</label>
                                <select
                                    value={opcionNotaCredito}
                                    onChange={(e) =>
                                        this.setState({ opcionNotaCredito: e.target.value })
                                    }
                                >
                                    <option value="">Selecciona</option>
                                    {tipoRelacionOptions.map((opt, idx) => (
                                        <option key={`${opt.value}-${idx}`} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="vd-field" style={{ marginTop: 12 }}>
                                <label>Forma de pago</label>
                                <select
                                    value={opcionFormaPago}
                                    onChange={(e) =>
                                        this.setState({ opcionFormaPago: e.target.value })
                                    }
                                >
                                    <option value="">Selecciona</option>
                                    {formaPagoOptions.map((opt, idx) => (
                                        <option key={`${opt.value}-${idx}`} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {bandera_nota_credito === "general" ? (
                                <div className="vd-field" style={{ marginTop: 12 }}>
                                    <label>Monto</label>
                                    <input
                                        className="vd-statInput"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        value={montoNotaCredito}
                                        onChange={(e) =>
                                            this.setState({ montoNotaCredito: e.target.value })
                                        }
                                        onBlur={() =>
                                            this.setState({
                                                montoNotaCredito: this.formatMoney(
                                                    this.parseNumber(this.state.montoNotaCredito)
                                                ),
                                            })
                                        }
                                        placeholder="0.00"
                                    />
                                </div>
                            ) : null}

                            <div className="vd-field" style={{ marginTop: 12 }}>
                                <label>Agregar detalles</label>
                                <textarea
                                    className="vd-textarea"
                                    value={descripcionDetallada}
                                    onChange={(e) =>
                                        this.setState({ descripcionDetallada: e.target.value })
                                    }
                                    placeholder="Escribe los detalles"
                                />
                            </div>

                            <div className="vd-miniActions">
                                <button
                                    type="button"
                                    className="vd-btn vd-btnGhost"
                                    onClick={this.closeMiniNotaCredito}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="button"
                                    className="vd-btn vd-btnPrimary"
                                    onClick={this.onGuardarNotaCredito}
                                >
                                    Guardar
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="vd-miniTitle">Confirmar nota de crédito</div>

                            <div className="vd-miniText">
                                ¿Estas seguro de agregar la nota de crédito?
                            </div>

                            <div className="vd-miniActions">
                                <button
                                    type="button"
                                    className="vd-btn vd-btnGhost"
                                    onClick={() => this.setState({ showConfirmNotaCredito: false })}
                                >
                                    Cancelar
                                </button>

                                <button
                                    type="button"
                                    className="vd-btn vd-btnPrimary"
                                    onClick={this.onConfirmarNotaCredito}
                                >
                                    Agregar
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    };

    renderCancelarFacturaModal = () => {
        const {
            showCancelarModal,
            showConfirmCancelarFactura,
            opcionCancelarFactura,
        } = this.state;

        const motivoCancelacionOptions = this.getMotivoCancelacionOptions();

        if (!showCancelarModal) return null;

        return (
            <div className="vd-miniBackdrop">
                <div className="vd-miniModal">
                    {!showConfirmCancelarFactura ? (
                        <>
                            <div className="vd-miniTitle">Cancelar factura</div>

                            <div className="vd-field" style={{ marginTop: 12 }}>
                                <label>Motivo de cancelación</label>
                                <select
                                    value={opcionCancelarFactura}
                                    onChange={(e) =>
                                        this.setState({ opcionCancelarFactura: e.target.value })
                                    }
                                >
                                    <option value="">Selecciona</option>
                                    {motivoCancelacionOptions.map((opt, idx) => (
                                        <option key={`${opt.value}-${idx}`} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="vd-miniActions">
                                <button
                                    type="button"
                                    className="vd-btn vd-btnGhost"
                                    onClick={this.closeCancelarFacturaModal}
                                >
                                    Cerrar
                                </button>

                                <button
                                    type="button"
                                    className="vd-btn vd-btnDanger"
                                    onClick={this.onGuardarCancelarFactura}
                                >
                                    Cancelar factura
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="vd-miniTitle">Confirmar cancelación</div>

                            <div className="vd-miniText">
                                ¿Estas seguro de cancelar?
                            </div>

                            <div className="vd-miniActions">
                                <button
                                    type="button"
                                    className="vd-btn vd-btnGhost"
                                    onClick={() => this.setState({ showConfirmCancelarFactura: false })}
                                >
                                    Cancelar
                                </button>

                                <button
                                    type="button"
                                    className="vd-btn vd-btnDanger"
                                    onClick={this.onConfirmarCancelarFactura}
                                >
                                    Aceptar
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    };

    render() {
        const { show, loading, onClose } = this.props;

        if (!show) return null;

        const {
            afiliacion,
            solicitud,
            emisor,
            pagos,
            productos,
            resumen,
        } = this.getData();

        const tipo_solicitud = (solicitud.tipo_solicitud || "").toUpperCase();
        const facturaCancelada = this.isFacturaCancelada();


        return (
            <div className="vd-backdrop vd-backdropTop">
                <div className="vd-modal vd-modalWide vd-modalTop vd-modalPublica">
                    <div className="vd-head">
                        <div className="vd-headText">
                            <div className="vd-title">Detalle de factura</div>
                        </div>

                        <button type="button" className="vd-close" onClick={onClose}>
                            ×
                        </button>
                    </div>

                    {loading ? (
                        <div className="vd-loading">Cargando detalles...</div>
                    ) : (
                        <>
                            {this.renderResumen()}

                            <div className="vd-body vd-bodyNoHorizontal">
                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">Afiliación</div>
                                            <div className="vd-cardDesc">
                                                Información principal de la afiliación.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderReadField("Afiliación", afiliacion.afiliacion)}
                                        {this.renderReadField("Moneda", afiliacion.moneda)}
                                        {this.renderReadField("Banco", afiliacion.banco)}
                                        {this.renderReadField("Compañía", afiliacion.compania)}
                                        {this.renderReadField("Cuenta", afiliacion.cuenta)}
                                        {this.renderReadField("Comentarios", afiliacion.comentarios, "vd-span-3")}
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">Información de factura</div>
                                            <div className="vd-cardDesc">Datos generales para la factura pública.</div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderReadField("Ticket", solicitud.idticket)}
                                        {this.renderReadField("Locación", solicitud.locacion, "vd-span-2")}
                                        {this.renderReadField("Nombre", solicitud.nombre)}
                                        {this.renderReadField("Apellido", solicitud.apellido)}
                                        {this.renderReadField("RFC", solicitud.rfc)}
                                        {this.renderReadField("Regimen Fiscal", solicitud.regimen_fiscal_descripcion)}

                                        {this.renderReadField("Domicilio Fiscal", solicitud.domicilio_fiscal)}



                                    </div>
                                </div>

                                {(tipo_solicitud === "EXTRANJERO" ||
                                    tipo_solicitud === "EXTRANJERA" ||
                                    tipo_solicitud === "TURISTA") && (
                                        <div className="vd-card">
                                            <div className="vd-cardHead">
                                                <div>
                                                    <div className="vd-cardTitle">Datos complementarios</div>
                                                </div>
                                            </div>

                                            <div className="vd-grid vd-gridTwoCols">
                                                {this.renderReadField("Nacionalidad", solicitud.nacionalidad)}
                                                {this.renderReadField("Residencia fiscal", solicitud.residencia_fiscal)}
                                                {this.renderReadField("Tipo ID", "Pasaporte")}

                                                {this.renderReadField("Pasaporte", solicitud.pasaporte)}
                                                {this.renderReadField("Fecha tránsito", solicitud.fecha_transito)}
                                                {this.renderReadField("Tipo transito", solicitud.tipo_transito)}
                                                {this.renderReadField("Vía", solicitud.via)}
                                                {this.renderReadField("Línea de Transporte", solicitud.linea_transporte)}
                                                {this.renderReadField("ID Transporte", solicitud.id_transporte)}
                                                {this.renderReadField("Carpeta", solicitud.carpeta)}
                                                {this.renderReadField("Comentarios", solicitud.comentarios)}
                                            </div>
                                        </div>
                                    )}

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">Emisor</div>
                                            <div className="vd-cardDesc">Información del emisor.</div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridTwoCols">
                                        {this.renderReadField("Nombre", emisor.nombre)}
                                        {this.renderReadField("RFC", emisor.rfc)}
                                        {this.renderReadField("Lugar Expedición", solicitud.lugar_expedicion)}
                                        {this.renderReadField("Régimen Fiscal", solicitud.regimen_fiscal_descripcion)}
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-cardHead">
                                        <div>
                                            <div className="vd-cardTitle">CFDI 4.0</div>
                                            <div className="vd-cardDesc">Datos fiscales de la factura.</div>
                                        </div>
                                    </div>

                                    <div className="vd-grid vd-gridSolicitud">
                                        {this.renderReadField("Serie", solicitud.serie || "—")}
                                        {this.renderReadField("Folio", solicitud.folio)}
                                        {this.renderReadField("Tipo Cambio", resumen.tipocambiofactura)}
                                        {this.renderReadField(
                                            "Forma Pago",
                                            `${solicitud.forma_pago || ""} ${solicitud.forma_pago_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField(
                                            "Método Pago",
                                            `${solicitud.metodo_pago || ""} ${solicitud.metodo_pago_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField(
                                            "Tipo Comprobante",
                                            `${solicitud.tipo_comprobante || ""} ${solicitud.tipo_comprobante_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField(
                                            "Uso CFDI",
                                            `${solicitud.uso_cfdi || ""} ${solicitud.uso_cfdi_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField("Moneda", resumen.monedafactura || solicitud.moneda)}
                                        {this.renderReadField("Cantidad", this.formatCurrency(solicitud.cantidad))}
                                        {this.renderReadField(
                                            "Periodicidad",
                                            `${solicitud.periodicidad || ""} ${solicitud.periodicidad_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField(
                                            "Mes",
                                            `${solicitud.meses || ""} ${solicitud.meses_descripcion || ""}`.trim()
                                        )}
                                        {this.renderReadField("Año", solicitud.anyo)}
                                    </div>
                                </div>


                                <div className="vd-card">
                                    <div className="vd-cardHead vd-cardHeadProducts">
                                        <div>
                                            <div className="vd-cardTitle">Pagos</div>
                                            <div className="vd-cardDesc">
                                                Información de pagos relacionados.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-tableWrap">
                                        <table className="vd-table">
                                            <thead>
                                                <tr>
                                                    <th>Ticket</th>
                                                    <th>Total</th>
                                                    <th>Moneda</th>
                                                    <th>Total Cobrado</th>
                                                    <th>Propina</th>
                                                    <th>T. C.</th>
                                                    <th>Facturable</th>
                                                    <th>Estatus</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pagos.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="9" className="vd-empty">
                                                            No hay pagos disponibles
                                                        </td>
                                                    </tr>
                                                ) : (() => {
                                                    const cantidadPagosConEstatus3 = pagos.filter(
                                                        p => Number(p.idestatus) === 3
                                                    ).length;

                                                    const mostrarBtnNotaCreditoGlobal =
                                                        !facturaCancelada &&
                                                        pagos.length > 1 &&
                                                        cantidadPagosConEstatus3 > 1;

                                                    return pagos.map((p, idx) => {
                                                        const mostrarBtnNotaCredito =
                                                            mostrarBtnNotaCreditoGlobal &&
                                                            Number(p.idestatus) === 3;

                                                        return (
                                                            <tr key={`${p.idticketpago || idx}`}>
                                                                <td>{p.idticket || "—"}</td>

                                                                <td>{this.formatCurrency(p.total)}</td>
                                                                <td>{p.moneda_cobro || "—"}</td>


                                                                <td style={{ fontWeight: p.diferencia === 1 ? "bold" : "normal", color: p.diferencia === 1 ? "red" : "black" }}>{this.formatCurrency(p.total_cobrado) || "—"}</td>



                                                                <td>{this.formatCurrency(p.propina)}</td>
                                                                <td>{p.tc || p.tipo_cambio || "—"}</td>

                                                                <td>
                                                                    {this.formatCurrency(
                                                                        p.facturado || p.facturableUSD || p.facturableMXN || 0
                                                                    )}
                                                                </td>

                                                                <td
                                                                    style={{
                                                                        color:
                                                                            Number(p.idestatus) === 3
                                                                                ? "green"
                                                                                : Number(p.idestatus) === 7
                                                                                    ? "red"
                                                                                    : "black",
                                                                    }}
                                                                >
                                                                    {p.estatus || "—"}
                                                                </td>

                                                                <td>
                                                                    {mostrarBtnNotaCredito ? (
                                                                        <button
                                                                            type="button"
                                                                            className="vd-btn vd-btnMiniAction"
                                                                            onClick={() => this.openMiniNotaCredito(p)}
                                                                        >
                                                                            Nota de crédito
                                                                        </button>
                                                                    ) : null}
                                                                </td>
                                                            </tr>
                                                        );
                                                    });
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>


                                <div className="vd-card">
                                    <div className="vd-cardHead vd-cardHeadProducts">
                                        <div>
                                            <div className="vd-cardTitle">Productos</div>
                                            <div className="vd-cardDesc">
                                                Información del producto facturado.
                                            </div>
                                        </div>
                                    </div>

                                    <div className="vd-tableWrap">
                                        <table className="vd-table">
                                            <thead>
                                                <tr>
                                                    <th>Producto</th>
                                                    <th>Cantidad</th>
                                                    <th>Clave SAT</th>
                                                    <th>IVA 16%</th>
                                                    <th>Subtotal</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productos.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="vd-empty">
                                                            No hay productos disponibles
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    productos.map((p, idx) => (
                                                        <tr key={p.idfacturaproductos || idx}>
                                                            <td>{p.producto || "VENTAS DEL DIA"}</td>
                                                            <td>{p.cantidad || 1}</td>
                                                            <td>{p.clave_sat || "—"}</td>
                                                            <td>{this.formatCurrency(p.iva || 0)}</td>
                                                            <td>{this.formatCurrency(p.subtotal || 0)}</td>
                                                            <td>{this.formatCurrency(p.total || 0)}</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="vd-card">
                                    <div className="vd-grid vd-gridFacturacionFinal">

                                        {this.renderReadField("T. C. Factura", resumen.tipocambiofactura)}

                                        {this.renderReadField("Moneda Factura", resumen.monedafactura)}

                                        {this.renderReadField("IVA Factura", this.formatCurrency(resumen.ivafactura))}
                                        {this.renderReadField("Total Factura", this.formatCurrency(resumen.totalfactura))}


                                    </div>
                                </div>
                            </div>

                            <div className="vd-foot vd-footSplit">
                                <div className="vd-footLeft"></div>

                                <div className="vd-footRight">
                                    <button
                                        type="button"
                                        className="vd-btn vd-btnGhost"
                                        onClick={onClose}
                                    >
                                        Cerrar
                                    </button>

                                    <button
                                        type="button"
                                        className="vd-btn vd-btnGhost"
                                        onClick={this.openNotaCreditoGenral}                                    >
                                        Nota de crédito
                                    </button>

                                    {!facturaCancelada && (
                                        <button
                                            type="button"
                                            className="vd-btn vd-btnDanger"
                                            onClick={this.openCancelarFacturaModal}
                                        >
                                            Cancelar factura
                                        </button>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {this.renderMiniModal()}
                {this.renderCancelarFacturaModal()}
            </div>
        );
    }
}